export const lttDevices = require("./linus_shortcircuit_overlay-fs8.png");
export const lttBG = require("./lttBG.png");
export const lttBGmobile = require("./lttBG_414.png");
export const lttBGtablet = require("./lttBG_1024.png");
export const lttShellsLogo = require("./LTT_shells_logos.png");
export const shortCircuitShellsLogo = require("./short-circuit_shells_logos.png");
